"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var Accordion_1 = __importDefault(require("@material-ui/core/Accordion"));
var AccordionActions_1 = __importDefault(require("@material-ui/core/AccordionActions"));
var Divider_1 = __importDefault(require("../Divider"));
var Accordion = react_1.forwardRef(function Accordion(_a, ref) {
    var actions = _a.actions, children = _a.children, props = __rest(_a, ["actions", "children"]);
    return (jsx_runtime_1.jsxs(Accordion_1.default, __assign({}, props, { ref: ref }, { children: [children, actions && (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [jsx_runtime_1.jsx(Divider_1.default, {}, void 0),
                    jsx_runtime_1.jsx(AccordionActions_1.default, { children: actions }, void 0)] }, void 0))] }), void 0));
});
exports.default = Accordion;
//# sourceMappingURL=ExpansionPanel.js.map